import styled, { css } from 'styled-components';
import { contentPadding } from './mixins';
import { media } from './media';

export const contentStyles = css`
  max-width: 1600px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const Content = styled.section`
  ${contentPadding};
  ${contentStyles};
`;

export const columnLayout = css`
  display: grid;
  grid-column-gap: 56px;
  grid-row-gap: 56px;
  grid-template-columns: 1fr;
  ${media.tablet`
    grid-template-columns: 1fr 1fr;
  `};
`;
